import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { CreateServiceModalComponent } from "../../../components/modal-templates/create-service-modal/create-service-modal.component";
import { DeleteConfirmationComponent } from "../../../components/modal-templates/delete-confirmation/delete-confirmation.component";
import { SharedImports } from "../../../components/shared.module";
import { AutomationActions } from "../../../core/ngrx/actions/automation.actions";
import {
  selectAllServices,
  selectServiceLoading,
} from "../../../core/ngrx/selectors/automation.selectors";
import { BaseLayoutComponent } from "../../base-layout.component";

@Component({
  selector: "app-api-service",
  standalone: true,
  imports: [CommonModule, ...SharedImports],
  templateUrl: "./api-service.component.html",
  styleUrl: "./api-service.component.scss",
})
export class ApiServiceComponent extends BaseLayoutComponent implements OnInit {
  private modalService = inject(NgbModal);
  isLoading: boolean = false;
  apiServices$!: Observable<any>;
  selectedCardToEdit: any;
  apiServiceDetails: any = [
    {
      type: "REST",
      subSectionName: "Rest API Services",
      addBtnText: "Add New Rest API Service",
      removeBtnText: "Remove Rest Services",
      dataList: [
        {
          id: "ts2",
          name: "Test Service 1",
          displayName: "Test Service 1",
          assetIcon: "assets/images/script/app-icon.svg",
          order: 1,
          level: 2,
          type: "api-service-view",
          view: "serviceView",
          isSelectable: true,
          isEditable: true,
          addApplicationTemplate: [],
          children: [],
          active: true,
        },
        {
          id: "ts3",
          name: "Test Service 3",
          displayName: "Test Service 3",
          assetIcon: "assets/images/script/app-icon.svg",
          order: 1,
          level: 2,
          type: "api-service-view",
          view: "serviceView",
          isSelectable: true,
          isEditable: true,
          addApplicationTemplate: [],
          children: [],
          active: true,
        },
      ],
    },
  ];
  iconSrcDelete: string =
    "../../../../../assets/images/virtusa-icons/remove-icon-dark.svg";
  selectedServices: any = [];
  automationProjectID: string = "";
  loadingServices$: Observable<boolean> =
    this.store.select(selectServiceLoading);
  ngOnInit(): void {
    this.loadingServices$.subscribe((loading) => {
      this.isLoading = loading;
    });

    this.projectService.getAutomationProjectId().subscribe((id: any) => {
      this.automationProjectID = id;
    });

    this.apiServices$ = this.store.select(selectAllServices);
    this.apiServices$.subscribe((services) => {
      let dataList: any = [];
      services.forEach((service: any) => {
        dataList.push({
          ...service,
          assetIcon: "assets/images/script/app-icon.svg",
          order: 1,
          level: 2,
          type: "api-service-view",
          view: "serviceView",
          isSelectable: true,
          isEditable: true,
          addApplicationTemplate: [],
          children: [],
          active: true,
        });
      });
      this.apiServiceDetails[0].dataList = dataList;
    });
  }

  addNewService(type: string, isEdit?: boolean, event?: any) {
    if (isEdit) {
      console.log("edit rest api", event);
    }
    if (type === "rest") {
      const modalRef = this.modalService.open(CreateServiceModalComponent, {
        centered: true,
        size: "lg",
        backdrop: 'static',
      });
      modalRef.componentInstance.configs = {
        title: isEdit ? "Update Rest API Service" : " Add New Rest API Service",
        saveBtnText: isEdit ? "Update" : "Add",
        isEdit: isEdit ? isEdit : false,
        data: isEdit ? event : null,
      };
      modalRef.result.then((result) => {
        if (isEdit) {
          this.store.dispatch(
            AutomationActions.updateService({
              projectId: this.dataStore?.data?.id,
              automationProjectId: this.automationProjectID,
              id: this.selectedCardToEdit?.id,
              changes: result,
            })
          );
        } else {
          this.store.dispatch(
            AutomationActions.addService({
              projectId: this.dataStore?.data?.id,
              automationProjectId: this.automationProjectID,
              apiService: result,
            })
          );
        }
      });
    }
  }

  changeRemoveIcon(isActive: boolean) {
    this.iconSrcDelete = isActive
      ? "../../../../../assets/images/virtusa-icons/remove-icon-light.svg"
      : "../../../../../assets/images/virtusa-icons/remove-icon-dark.svg";
  }

  refreshData() {
    this.store.dispatch(
      AutomationActions.loadService({
        projectId: this.dataStore?.data?.id,
        automationProjectId: this.automationProjectID,
      })
    );
  }

  removeComponents() {
    let modalRef = this.modalService.open(DeleteConfirmationComponent, {
      centered: true,
      windowClass:"delete-confirmation-window",
      size: "sm",
      backdrop: "static",
    });
    modalRef.result.then((result: any) => {
      if (result) {
        this.store.dispatch(
          AutomationActions.deleteServices({
            projectId: this.dataStore?.data?.id,
            automationProjectId: this.automationProjectID,
            idList: this.selectedServices.map((item: any) => item?.id),
          })
        );
      }
    });
  }

  handleSelectedCards(selectedCards: any[]) {
    this.selectedServices = selectedCards;
  }

  onEditFolder(event: any) {
    this.selectedCardToEdit = event?.$event;
    this.addNewService("rest", true, event?.$event);
  }
}
